<div class="modal-header">
    <h5 class="modal-title">Görev Yönetimi</h5>
    <button type="button" class="close" (click)="closeModal(false)" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="mb-3 d-flex gap-2">
        <input type="text" class="form-control" placeholder="Görev adı girin..." [(ngModel)]="missionName" />

        <button *ngIf="editMode" class="btn btn-danger" (click)="cancelEdit()">
            <span data-feather="x"></span>
        </button>
    </div>

    <table class="table table-bordered table-sm align-middle text-center">
        <thead class="table-light">
            <tr>
                <th>#</th>
                <th>Görev Adı</th>
                <th>İşlemler</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let mission of missions; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ mission.name }}</td>
                <td>
                    <button class="btn btn-sm btn-flat-warning me-2" (click)="editMission(mission)">
                        <span data-feather="edit"></span>
                    </button>
                    <button class="btn btn-sm btn-flat-danger" appDelete controller="Missions" [id]="mission.id"
                        (callback)="getAllMission()">
                        <span data-feather="trash"></span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="closeModal()">Kapat</button>
    <button class="btn btn-outline-primary" (click)="saveMission()" [disabled]="!missionName">
        Kaydet
    </button>
</div>